import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Text,
    Heading,
    Flex,
    IconButton,
    Grid,
    GridItem,
    useColorModeValue,
    useColorMode,
} from '@chakra-ui/react';
import { useBreakpointValue } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom'; 
import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons';
import Boxx from '../../components/common/boxhome/boxx';
import Footer from "../../components/footer/footer";
import Lottie from 'lottie-react';
import Ai1 from '../../lotti-file/seo/keyworlds.json';
import Ai2 from '../../lotti-file/seo/onepageoptimization.json';
import Ai3 from '../../lotti-file/seo/technicalseo.json';
import Ai4 from '../../lotti-file/seo/linkbuliding.json';
import Ai5 from '../../lotti-file/seo/localseo.json';
import Ai6 from '../../lotti-file/seo/contentoptimization.json';

import Ai7 from '../../lotti-file/seo/keyworldwhite.json';
import Ai8 from '../../lotti-file/seo/onepagewhite.json';
import Ai9 from '../../lotti-file/seo/technicalwhite.json';
import Ai10 from '../../lotti-file/seo/linkwhite.json';
import Ai11 from '../../lotti-file/seo/localwhite.json';
import Ai12 from '../../lotti-file/seo/contantwhite.json';


const solutions = [
    { title: "Digital Branding Solutions", path: "/digitalbranding" },
    { title: "Awareness Growth Solutions", path: "/awarenesssoutions" },
    { title: "Revenue Growth Solutions", path: "/revenuegrowth" },
    { title: "Social Media Management", path: "/socialmedia" },
    { title: "SEO", path: "/seo" },
    { title: "Performance Marketing", path: "/performancemarketing" },
];


const services = [
    { title: <Text as="span">'Keyword<Text as="span" color="#FE3A3A"> Research</Text> </Text>, description: 'We identify high-value keywords to ensure your content ranks for the terms your audience is searching for.', animationDataLight: Ai7, animationDataDark: Ai1, },
    { title: <Text as="span">On-Page <Text as="span" color="#FE3A3A">Optimization</Text> </Text>, description: 'Optimize your website’s structure, content, and meta tags to improve relevance and visibility in search engines.', animationDataLight: Ai8, animationDataDark: Ai2, },
    { title: <Text as="span">Technical <Text as="span" color="#FE3A3A">SEO</Text> </Text>, description: 'From improving site speed to ensuring mobile-friendliness, we handle the technical aspects of SEO that drive higher rankings.', animationDataLight: Ai9, animationDataDark: Ai3, },
    { title: <Text as="span">Link <Text as="span" color="#FE3A3A">Building</Text></Text>, description: 'Build your site’s authority through strategic backlinks that improve search engine trust and performance.', animationDataLight: Ai10, animationDataDark: Ai4, },
    { title: <Text as="span">Local <Text as="span" color="#FE3A3A">SEO</Text></Text>, description: 'Optimize your website and listings to attract local customers and improve your visibility in local searches.', animationDataLight: Ai11, animationDataDark: Ai5, },
    { title: <Text as="span">Content  <Text as="span" color="#FE3A3A">Optimization</Text></Text>, description: 'Regularly update and optimize your site’s content to ensure it stays relevant and competitive in search rankings.', animationDataLight: Ai12, animationDataDark: Ai6, },

]

const Digitalbranding: React.FC = () => {
    const { colorMode } = useColorMode();
    const navigate = useNavigate(); 
    const scrollRef = useRef<HTMLDivElement>(null);
    const pathData = useBreakpointValue({
        base: "M0 10 Q75 0 200 10",
        md: "M0 20 Q150 0 300 20"
    });
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const selectedIndex = solutions.findIndex((solution) => solution.path === location.pathname);
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

    const handleSolutionClick = (index: number, path: string) => {
        setLoading(true);

        setTimeout(() => {
            navigate(path);
        }, 500);
    };

    useEffect(() => {
        if (selectedIndex !== null && itemRefs.current[selectedIndex]) {
            itemRefs.current[selectedIndex]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
        document.documentElement.scrollTop = 0; 
        document.body.scrollTop = 0;
    }, [selectedIndex, location.pathname]);
    const bg = useColorModeValue('white', '#1C1C1C')
    const color = useColorModeValue('#FFFFF', 'white')
    const textColor = useColorModeValue('#1C1C1C', 'white');
    const selectedTextColor = 'white';
    return (
        <Grid
            bg={bg}
            templateColumns="1fr"
            gap={4}
            p={4}
            width="full"
            marginTop="auto"
        >
            <Box textAlign="center" mt={{ base: "10px", md: "20px" }} position="relative">
                <Text
                    fontSize={{ base: "12px", md: "28px" }}
                    lineHeight="36px"
                    fontWeight="400"
                >
                    <span color={color} style={{ fontFamily: "'Gilroy-Regular', sans-serif" }}>
                        Service /{' '}
                    </span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>
                        SEO
                    </span>
                </Text>

                <Box mt={{ base: 'auto', md: '20px' }} display="inline-block" ml={{ base: '150px', md: '320px' }}>
                    <svg width="32%" height="auto" viewBox="0 0 300 40">
                        <path
                            d={pathData}
                            fill="none"
                            stroke={colorMode === 'light' ? 'black' : 'silver'}
                            strokeWidth="2"
                        />
                    </svg>
                </Box>
            </Box>

            <Box textAlign="center" mt={{ base: "10px", md: "20px" }} position="relative">
                <Text
                    fontSize={{ base: "32px", md: "64px" }}
                    lineHeight={{ base: "40px", md: "78px" }}
                    fontWeight="400"
                >
                    <span color={color} style={{ fontFamily: "'Gilroy-Regular', sans-serif" }}>
                        What {' '}
                    </span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>
                        we offer
                    </span>
                </Text>
            </Box>

            <Box
                ref={scrollRef}
                overflowX="auto"
                whiteSpace="nowrap"
                flexGrow={1}
                p={1}
                width="full"
                sx={{
                    '::-webkit-scrollbar': { display: 'none' },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                }}
            >
                <Flex
                    width="100%"
                    gap={6}
                    flexDirection="row"
                    overflowX="auto"
                    padding="10px"
                    maxWidth="100%"
                    sx={{
                        '::-webkit-scrollbar': {
                            display: 'none',
                        },
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none',
                    }}
                >
                    {solutions.map((solution, index) => (
                        <Box
                            key={solution.title}
                            ref={(el) => itemRefs.current[index] = el} 
                            onClick={() => handleSolutionClick(index, solution.path)}
                            borderRadius="md"
                            padding="10px"
                            fontFamily="'Gilroy-Regular', sans-serif"
                            cursor="pointer"
                            transition="background-color 0.3s"
                            bg={selectedIndex === index ? 'red.500' : 'transparent'}
                            flexShrink={0} 
                        >
                            <Text
                                fontSize={{ base: "20px", md: "28px" }}
                                color={selectedIndex === index ? selectedTextColor : textColor}
                            >
                                {solution.title}
                            </Text>
                        </Box>
                    ))}
                </Flex>
            </Box>

            <Box
                height={{ base: "50vh", md: "100vh" }}
                width="100%"
                maxWidth="auto"
                bg="#000000"
                backgroundImage="url('/assets/images/svg/seo.jpg')"
                backgroundSize="cover"
                backgroundPosition="center"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="20px"
                mt={4}
                opacity={1}
            >
              
            </Box>

            <Box textAlign="left" mt="10px">
                <Text
                    fontSize={{ base: '28px', md: '52px' }}
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                    color={color}
                >
                    Descriptions
                </Text>
                <Text
                    order={{ base: 1, md: 0 }} 
                    fontFamily="'Gilroy-Regular', sans-serif"
                    fontSize={{ base: '16px', md: '28px' }}
                    fontWeight="400"
                    lineHeight={{ base: '24px', md: '36px' }}
                    color={color}
                    maxWidth={{ base: 'auto', md: 'auto' }}
                    textAlign="justify" 
                    pl="10px"
                    pr="10px"
                    mt="20px"
                    letterSpacing={{ base: '0.5px' }}

                >
                    Our SEO services help your business rise to the top of search engine results, making it easier for your audience to find you. Through a combination of technical optimization, strategic keyword targeting, and content development, we ensure your site is optimized for both search engines and users.
                </Text>
            </Box>



            <Grid
                mt="30px"
                templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
                gap={{ base: 4, md: 6 }}
                p={{ base: 2, md: 4 }}
                maxWidth="100%"
                height="auto"
                mx="auto"
                overflowX="hidden"
            >
                {services.map((service, index) => (
                    <GridItem key={index} position="relative" display="flex" justifyContent="center">
                        <Box
                            borderRadius="md"
                            p={4}
                            borderColor="gray.600"
                            mb={4}
                            textAlign="center"
                            mx="auto"
                            width="100%"
                        >
                            {/* Lottie Box */}
                            <Box
                                mb={{ base: 2, md: -5 }}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                ml={{ md: "-10px" }}
                                width={{ base: '100px', md: '255px' }}
                                height={{ base: '60px', md: '162px' }}
                                mx="auto"
                                order={{ base: 0, md: -1 }}
                            >
                                {/* Lottie Animation */}
                                <Lottie
                                    animationData={colorMode === 'light' ? service.animationDataLight : service.animationDataDark}
                                    loop={true}
                                />
                            </Box>

                            {/* Title and Description */}
                            <Box display="flex" flexDirection="column" alignItems={{ base: 'center', md: 'flex-start' }} mt={4}>
                                <Text
                                    fontSize={{ base: '16px', md: '40px' }}
                                    fontWeight="400"
                                    color={colorMode === 'light' ? 'black' : 'white'} 
                                    whiteSpace="nowrap"
                                    overflow="visible"
                                    fontFamily="'Gilroy-SemiBold', sans-serif"
                                    textOverflow="ellipsis"
                                    maxWidth="100%"
                                    textAlign="center"
                                    mt={{ base: '0', md: '0' }}
                                >
                                    {service.title}
                                </Text>
                                <Text
                                    color={colorMode === 'light' ? 'black' : 'white'} 
                                    fontSize={{ base: '14px', md: '25px' }}
                                    mt={1}
                                    textAlign="justify"
                                    fontFamily="'Gilroy-SemiBold', sans-serif"
                                >
                                    {service.description}
                                </Text>
                            </Box>

                            {/* Gradient border */}
                            <Box
                                mt={4}
                                border="1px solid"
                                sx={{
                                    borderImageSource:
                                        colorMode === "light"
                                            ? "linear-gradient(270deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)"
                                            : "linear-gradient(270deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)",
                                    borderImageSlice: 1,
                                }}
                            />
                        </Box>

                        {/* Gradient divider between items only on larger screens */}
                        {index % 2 === 0 && index < services.length - 1 && (
                            <Box
                                display={{ base: 'none', md: 'block' }}
                                position="absolute"
                                top={0}
                                bottom={0}
                                right={0}
                                width="1px"
                                background={
                                    colorMode === 'light'
                                        ? 'linear-gradient(473deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
                                        : 'linear-gradient(473deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)'
                                }
                                height="100%"
                                transform="translateX(50%)"
                            />
                        )}
                    </GridItem>
                ))}
            </Grid>


            {/* BrandingInfoList component added here */}
            <Box mt={{ base: "50px", md: "100px" }} textAlign="center">
                <Text fontFamily="'Gilroy-Regular', sans-serif" fontSize={{ base: "12px", md: "28px" }} color={color}>
                    Frequently Asked Questions
                </Text>

                {/* "Our Top Services" Heading for mobile */}
                <Box textAlign="center" mt={{ base: '30px', md: '50px' }}>
                    <Heading
                        fontFamily="'Gilroy-SemiBold', sans-serif"
                        fontSize={{ base: "32px", md: "64px" }}  
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "78px" }}
                        letterSpacing="-0.25px"
                        color={color}
                    >
                        <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> Questions?</Text>
                    </Heading>

                    <Text
                        fontFamily="'Cags Hetonal', sans-serif"
                        fontSize={{ base: "32px", md: "64px" }}
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "78px" }} 
                        letterSpacing="-0.25px"
                        mt="10px"
                    >
                        <Text as="span" color={color}>Your </Text>
                        <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">Answers </Text>
                        <Text as="span" color={color} fontFamily="'Gilroy-SemiBold', sans-serif">are here  </Text>
                    </Text>
                </Box>
            </Box>

            <BrandingInfoList />
            <Text color={color} mt={{ base: "40px", md: "100px" }} fontSize={{ base: '12px', md: '28px' }} textAlign='center' fontFamily="'Gilroy-Medium', sans-serif">
                Get In Touch
            </Text>
            <Boxx />
            <Footer />
        </Grid>
    );
};

interface BrandingInfoProps {
    title: string;
    content: string;
}

const BrandingInfo: React.FC<BrandingInfoProps> = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);
    const bg = useColorModeValue('white', '#1C1C1C')
    const color = useColorModeValue('#FFFFF', 'white')
    return (
        <Box
            bg={bg}
            maxW="auto"
            borderRadius={{ base: '10px', md: '20px' }}
            color={color}
            border={isOpen ? '1px solid #FE3A3A' : 'none'}
            overflow="hidden"
            mt={{ base: '10px', md: '14px' }} 
        >
            <Box
                display="flex"
                justifyContent="space-between"
                onClick={() => setIsOpen(!isOpen)}
                cursor="pointer"
                alignItems="center"
                border={isOpen ? '2px solid #FE3A3A' : 'none'}
                borderRadius="md"
                p={{ base: '10px', md: '20px' }} 
                backgroundColor={isOpen ? '#FE3A3A' : 'transparent'}
            >
                <Text
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                    fontWeight="400"
                    fontSize={{ base: "16px", md: "32px" }} 
                    lineHeight={{ base: "24px", md: "40px" }}
                >
                    {title}
                </Text>
                <IconButton
                    aria-label={isOpen ? "Collapse" : "Expand"}
                    icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    fontSize={{ base: "24p  x", md: "30px" }}
                    variant="outline"
                    color={color}
                    borderColor="white"
                    _hover={{ bg: 'transparent' }}
                    p={{ base: 1, md: 1 }}
                />
            </Box>
            <Box p={isOpen ? 4 : 0} maxH={isOpen ? 'auto' : '0'} transition="max-height 0.2s ease-out">
                <Text
                    fontFamily="'Gilroy-Regular', sans-serif"
                    fontSize={{ base: "16px", md: "28px" }} 
                    lineHeight={{ base: '24px', md: '36px' }} 
                >
                    {content}
                </Text>
            </Box>
        </Box>
    );
};

const BrandingInfoList: React.FC = () => {
    return (
        <Box>
            <BrandingInfo title="How can SEO help my business grow in India?" content="SEO helps your website rank higher on search engines like Google, making it easier for potential customers to find you. In a competitive market like India, SEO is crucial for driving organic traffic and leads." />
            <BrandingInfo title="How long does it take to see results from SEO?" content="SEO is a long-term strategy. It typically takes 3-6 months to see significant improvements in rankings and traffic, but the results are long-lasting and sustainable." />
            <BrandingInfo title="Is SEO worth investing in for small businesses and startups?" content="Yes, SEO is cost-effective and particularly beneficial for startups. It helps you attract customers organically without spending large amounts on paid ads, allowing you to build a steady flow of traffic over time." />
            <BrandingInfo title="How can I start seeing SEO results quickly as a startup?" content="While SEO takes time, quick wins like optimizing your website for local searches and targeting less competitive keywords can help you start seeing improvements within a few weeks." />
            <BrandingInfo title="What’s the difference between local and national SEO?" content="Local SEO targets customers in a specific geographical area, which is ideal for businesses that serve a local market. National SEO, on the other hand, focuses on reaching a broader, countrywide audience." />
        </Box>
    );
};

export default Digitalbranding;
